import React from 'react';

const CommonNoAuthPageAccess: React.FC = () => {
  return (
    <div style={{ margin: 20, textAlign: 'center' }}>
      <h3>No Access</h3>
      <p>You don't have permission to view this document.</p>
    </div>
  );
};

export default CommonNoAuthPageAccess;

